module.exports = __webpack_public_path__ + "img/2024-10-16f_2.daaf79d9.jpg";